import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-widget-services',
  templateUrl: './widget-services.component.html',
  styleUrls: ['../widgets.scss', './widget-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class WidgetServicesComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  totalServices: number;

  isLoading$: Observable<boolean>;

  totalLocations$ = this.store.select(fromStore.getTotalActiveServiceLocations);

  totalOpenServices$ = this.store.select(fromStore.getActiveServices);

  ngOnInit(): void {
    this.isLoading$ = this.store.select(fromStore.getServicesLoading);

    this.store
      .select(fromStore.getServicesLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadServices());
        }
      });
  }
}
